import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, injectIntl } from 'react-intl';
import validator from 'validator';
import * as _ from 'lodash';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import injectReducer from 'utils/injectReducer';
import { makeSelectClaimTypeList } from 'containers/FastCover/StepWhatHappened/selectors';
import { makeSelectStepRentalVehicle, makeSelectStepRentalVehicleErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import { handleFormDataChange, nextSlide, resetFormData } from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation';
import { required } from '../../../utils/validation/validator';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import { stepRentalVehicleExpenseLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import CurrencySelector from '../components/CurrencySelector';

export class StepRentalVehicle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentDidMount() {
    const claimTypesList = !!this.props.claimTypes && (typeof this.props.claimTypes.toJS === 'function') ? this.props.claimTypes.toJS() : this.props.claimTypes;
    const hasClaimTypesLoaded = claimTypesList.length > 1;
    if (!hasClaimTypesLoaded) {
      return;
    }
    this.props.onFormDataChange('form.areYouClaimingForRentalVehicleExcess', !!stepRentalVehicleExpenseLookup.areYouClaimingForRentalVehicleExcess.claimCode ? 'true' : 'false');
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(8);
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getValidationErrors() {
    const { areYouClaimingForRentalVehicleExcess } = this.props.form;
    const errors = [];

    if (areYouClaimingForRentalVehicleExcess === 'true') {
      if (this.validateTableField()) {
        errors.push({
          field: 'expenseTable',
          message: 'Expense table fields are required fields.',
        });
      }
    }

    return errors;
  }

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    // this.props.makeDirty(8);
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  validateTableField() {
    const {
      rentalVehicleExcessAmount,
      rentalVehicleExcessAmountCurrency,
      actualRepairAmount,
      actualRepairAmountCurrency,
      amountClaimed,
      amountClaimedCurrency,
    } = this.props.form;
    const groups = [
      rentalVehicleExcessAmount,
      rentalVehicleExcessAmountCurrency,
      actualRepairAmount,
      actualRepairAmountCurrency,
      amountClaimed,
      amountClaimedCurrency,
    ];
    const invalid = _.some(groups, (value) => {
      const newValue = value ? value.toString() : '';
      return validator.isEmpty(newValue);
    });
    return invalid;
  }

  handleDayChange = (propertyName) => (day) => {
    const localDate = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, localDate);
    // this.props.makeDirty(8);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  renderExplainForm() {
    const { isSummary, submitted } = this.props;
    const {
      nameOfThePersonDrivingTheCar,
      driverDateOfBirth,
      dateOfExpense,
      rentalVehicleExcessAmount,
      rentalVehicleExcessAmountCurrency,
      actualRepairAmount,
      actualRepairAmountCurrency,
      amountClaimed,
      amountClaimedCurrency,
    } = isSummary ? this.summaryFormValue() : this.props.form;

    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <div className="row">
          <div className="form-group col-sm-4">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="nameOfThePersonDrivingTheCar"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={nameOfThePersonDrivingTheCar}
              fieldName={messages.nameOfThePersonDrivingTheCar}
            >
              <Textbox
                disabled={isReadOnly}
                name="nameOfThePersonDrivingTheCar"
                type="text"
                onChange={this.handleChange(
                  'form.nameOfThePersonDrivingTheCar'
                )}
                value={nameOfThePersonDrivingTheCar}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.nameOfThePersonDrivingTheCar}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-sm-4">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="driverDateOfBirth"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={driverDateOfBirth}
              fieldName={messages.driverDateOfBirth}
            >
              <DatePicker
                position={'bottom-start'}
                disabled={isReadOnly}
                name="driverDateOfBirth"
                type="text"
                onDayChange={this.handleDayChange('form.driverDateOfBirth')}
                value={driverDateOfBirth}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.driverDateOfBirth}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-sm-4">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="dateOfExpense"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={dateOfExpense}
              fieldName={messages.dateOfExpense}
            >
              <DatePicker
                position={'bottom-start'}
                disabled={isReadOnly}
                name="dateOfExpense"
                type="text"
                onDayChange={this.handleDayChange('form.dateOfExpense')}
                value={dateOfExpense}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: this.props.intl.formatMessage(messages.dateOfExpense) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-6">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="rentalVehicleExcessAmount"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={rentalVehicleExcessAmount}
              fieldName={messages.rentalVehicleExcessAmount}
            >
              <Textbox
                disabled={isReadOnly}
                name="rentalVehicleExcessAmount"
                type="number"
                onChange={this.handleChange('form.rentalVehicleExcessAmount')}
                value={rentalVehicleExcessAmount}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.rentalVehicleExcessAmount}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-6 col-sm-6">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="rentalVehicleExcessAmountCurrency"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={rentalVehicleExcessAmountCurrency}
              fieldName={messages.currency}
            >
              <CurrencySelector
                menuPlacement={'bottom'}
                name="rentalVehicleExcessAmountCurrency"
                onChange={(value) => { this.props.onFormDataChange('form.rentalVehicleExcessAmountCurrency', value); }}
                disabled={isReadOnly}
                value={rentalVehicleExcessAmountCurrency}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-6">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="actualRepairAmount"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={rentalVehicleExcessAmount}
              fieldName={messages.actualRepairAmount}
            >
              <Textbox
                disabled={isReadOnly}
                name="actualRepairAmount"
                type="number"
                onChange={this.handleChange('form.actualRepairAmount')}
                value={actualRepairAmount}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.actualRepairAmount}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-6 col-sm-6">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="actualRepairAmountCurrency"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={actualRepairAmountCurrency}
              fieldName={messages.currency}
            >
              <CurrencySelector
                maxHeight={100}
                name="actualRepairAmountCurrency"
                onChange={(value) => { this.props.onFormDataChange('form.actualRepairAmountCurrency', value); }}
                disabled={isReadOnly}
                value={actualRepairAmountCurrency}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-6">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="amountClaimed"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={amountClaimed}
              fieldName={messages.amountClaimed}
            >
              <Textbox
                disabled={isReadOnly}
                name="amountClaimed"
                type="number"
                onChange={this.handleChange('form.amountClaimed')}
                value={amountClaimed}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.amountClaimed}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-6 col-sm-6">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="amountClaimedCurrency"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={amountClaimedCurrency}
              fieldName={messages.currency}
            >
              <CurrencySelector
                name="amountClaimedCurrency"
                onChange={(value) => { this.props.onFormDataChange('form.amountClaimedCurrency', value); }}
                disabled={isReadOnly}
                value={amountClaimedCurrency}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
      </div>
    );
  }

  renderClaimingForm() {
    return this.renderExplainForm();
  }

  render() {
    const { isSummary, submitted, loading } = this.props;
    const isRenderAreYouClaimingForRentalVehicleExcess = !!stepRentalVehicleExpenseLookup.areYouClaimingForRentalVehicleExcess.claimCode;
    return (
      <div className="app-content">
        {isRenderAreYouClaimingForRentalVehicleExcess && this.renderClaimingForm()}

        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}

        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepRentalVehicle.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  // onReset: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.number,
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  adjust: PropTypes.func,
  onNext: PropTypes.func,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  claimTypes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepRentalVehicle(),
  errors: makeSelectStepRentalVehicleErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  claimTypes: makeSelectClaimTypeList(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onReset: () => dispatch(resetFormData()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepRentalVehicle', reducer });

export default compose(
  withReducer,
  injectIntl,
  withConnect
)(StepRentalVehicle);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepRentalVehicle/index.js